import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export function createLevelCongratulationsPageStyles({
  viewportHeight,
  spacing,
}: Theme) {
  return {
    text: css({
      maxWidth: 280,
    }),
    loaderWrapper: css({
      position: "absolute",
      width: "100%",
      left: 0,
      display: "flex",
      justifyContent: "center",
      margin: `${spacing(2)} auto`,
    }),
    star: css({
      position: "fixed",
    }),
    star1: css({
      bottom: 98,
      left: "14.75%",
    }),
    star2: css({
      bottom: 49,
      left: "35%",
    }),
    star3: css({
      bottom: 154,
      right: "27%",
      [(viewportHeight.down.md, "@media (max-width: 420.97px)")]: {
        display: "none",
      },
    }),
    star4: css({
      bottom: 101,
      left: "45.75%",
    }),
    star5: css({
      bottom: 88,
      right: "13.5%",
    }),
    star6: css({
      bottom: 185,
      left: 0,
    }),
    star7: css({
      bottom: 139,
      left: "2.5%",
    }),
    star8: css({
      bottom: 17,
      left: "8.5%",
    }),
    star9: css({
      bottom: 30,
      right: "21%",
    }),
    star10: css({
      bottom: 0,
      right: "31%",
    }),
    star11: css({
      bottom: 175,
      right: "4.25%",
    }),
    star12: css({
      bottom: 117,
      right: 0,
    }),
    star13: css({
      bottom: 173,
      left: "24.25%",
    }),
    star14: css({
      bottom: 5,
      right: "4.25%",
    }),
  };
}
